<template>
    <div v-if="addRuleStore.selectedRuleType === AcademyResultsRule.ScoreForAwardedMedals">
        <ScoreForAwardedMedalsRuleInput />
    </div>
    <div v-if="addRuleStore.selectedRuleType === AcademyResultsRule.ScoreForWonMatches">
        <ScoreForWonMatchesRuleInput />
    </div>
</template>

<script setup lang="ts">
    import { useAddRuleStore } from "./addRuleStore";
    import { AcademyResultsRule } from "../../Api/competitorResultsApi";
    import ScoreForAwardedMedalsRuleInput from "./ScoreForAwardedMedalsRuleInput.vue";
    import ScoreForWonMatchesRuleInput from "./ScoreForWonMatchesRuleInput.vue";

    const addRuleStore = useAddRuleStore();
</script>

<style scoped></style>
